import { render, staticRenderFns, recyclableRender, components } from "./merchantNews.vue?vue&type=template&id=2f225d3e&scoped=true&"
var renderjs
import script from "./merchantNews.vue?vue&type=script&lang=js&"
export * from "./merchantNews.vue?vue&type=script&lang=js&"
import style0 from "./merchantNews.vue?vue&type=style&index=0&id=2f225d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f225d3e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/merchantNews.vue"
export default component.exports